import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirm: 'Duplicate',
    description: 'Reuse your items for your next invoice.',
    errorMessage:
      'An error occurred while duplicating your invoice. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    title: 'Duplicate your invoice',
  },
  fr: {
    cancel: 'Annuler',
    confirm: 'Dupliquer',
    description: 'Réutilisez vos éléments pour votre prochaine facture.',
    errorMessage:
      'Une erreur est survenue lors de la duplication de votre facture. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    title: 'Dupliquer votre facture',
  },
} as const);
